/** People Landing — campos del bloque "callout". Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx. */
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import type { EditorFieldProps } from '../types';

export function CalloutFields({ draft, set }: EditorFieldProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.eyebrow_short', 'Etiqueta chica (opcional)')}</Label>
        <Input value={draft.eyebrow ?? ''} maxLength={80} onChange={(e) => set({ eyebrow: e.target.value })} />
      </div>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.title', 'Título')}</Label>
        <Input value={draft.title ?? ''} onChange={(e) => set({ title: e.target.value })} />
      </div>
      <div className="space-y-1.5">
        <Label>{t('people_landing.editor.callout_text', 'Texto corto (opcional)')}</Label>
        <Textarea value={draft.text ?? ''} rows={3} onChange={(e) => set({ text: e.target.value })} />
      </div>
      <div className="grid grid-cols-2 gap-3 items-end">
        <div className="space-y-1.5">
          <Label>{t('people_landing.editor.tone', 'Color de fondo')}</Label>
          <div className="flex gap-2">
            {([
              ['purple', '#F3EEFF', '#CEABFF'],
              ['green', '#E5F9F7', '#1CC9B9'],
              ['blue', '#EBF7FF', '#87DBFF'],
              ['orange', '#FEF1EC', '#FE805B'],
            ] as const).map(([tone, bg, ring]) => (
              <button
                key={tone}
                type="button"
                aria-label={tone}
                aria-pressed={(draft.tone ?? 'purple') === tone}
                onClick={() => set({ tone })}
                className={cn(
                  'h-8 w-8 rounded-full border-2 transition-transform',
                  (draft.tone ?? 'purple') === tone ? 'scale-110' : 'border-transparent hover:scale-105'
                )}
                style={{ background: bg, borderColor: (draft.tone ?? 'purple') === tone ? ring : undefined }}
              />
            ))}
          </div>
        </div>
        <div className="space-y-1.5">
          <Label>{t('people_landing.editor.link_optional', 'Link (opcional)')}</Label>
          <Input value={draft.url ?? ''} onChange={(e) => set({ url: e.target.value })} placeholder="https://…" />
        </div>
      </div>
    </>
  );
}
